import { formatOption } from './options';

export type SkillToolAction = 'Deleted' | 'Updated' | 'Used';
export type ToolCallVerb = SkillToolAction | 'Created';

export const SKILL_TOOL_ACTIONS: Record<string, SkillToolAction> = {
  delete_skill: 'Deleted',
  read_skill: 'Used',
  update_skill: 'Updated',
};

const PRESENT_TENSE_VERBS: Record<ToolCallVerb, string> = {
  Created: 'Creating',
  Deleted: 'Deleting',
  Updated: 'Updating',
  Used: 'Using',
};

const REPLY_TO_INTERNAL_CHAT_TOOL_NAME = 'reply_to_internal_chat_conversation';

export function getSkillToolCallId(toolInput: object): string | undefined {
  const skillId = (toolInput as Record<string, unknown>).skillId;
  return typeof skillId === 'string' ? skillId : undefined;
}

export function formatToolName(toolName: string): string {
  return formatOption(
    toolName
      .replace(/originator/g, 'customer')
      .replace(/action_execution/g, 'task')
  );
}

export function toToolCallVerb(verb: ToolCallVerb, isRunning: boolean): string {
  return isRunning ? PRESENT_TENSE_VERBS[verb] : verb;
}

export function formatToolCallLabel({
  toolName,
  skillName,
  isRunning = false,
}: {
  toolName: string;
  skillName?: string;
  isRunning?: boolean;
}): string {
  const skillAction = SKILL_TOOL_ACTIONS[toolName];
  return skillAction && skillName
    ? `${toToolCallVerb(skillAction, isRunning)} skill - ${skillName}`
    : `${toToolCallVerb('Used', isRunning)} tool - ${formatToolName(toolName)}`;
}

export function isReplyToConversation(
  { toolName, toolInput }: { toolName: string; toolInput: object },
  conversationId: string
): boolean {
  return (
    toolName === REPLY_TO_INTERNAL_CHAT_TOOL_NAME &&
    (toolInput as Record<string, unknown>).conversationId === conversationId
  );
}
